<app-dialog-header>
    <h1 class="app-dialog-title">{{ dialogTitle }}</h1>
</app-dialog-header>
<ng-template appUploadDialogContent></ng-template>
